import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceDown3.vue?vue&type=template&id=4be15464&"
import script from "./FaceDirectionResultEffectFaceDown3.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceDown3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports